import React from "react";

// importation style
import "./style.css";

// impotation components
import Products from "../products";

export default function Home() {
    return (
        <div className="Home">
            <div className="home text-white uppercase">
                <div className="containeer mx-auto w-11/12 h-full flex items-center">
                    <div>
                        <h1 className=" md:text-6xl text-5xl text-bold">
                            new seadon arrivals
                        </h1>
                        <h1 className="py-3 text-3xl">
                            check out all the trends
                        </h1>
                    </div>
                </div>
            </div>
            <Products />
        </div>
    );
}
